<template>
  <div>
    <div v-if="dialIsAllow">
      <div v-if="!btnCallDisabled">
        <div v-if="btnIsCalling">
          <v-tooltip left>
            <template v-slot:activator="{ on }">
              <v-btn
                v-on="on"
                fab
                small
                class="btn-phone m-r-10"
                color="success"
                @click="toggleDialPanel"
              >
                <v-icon size="20" color="white"> mdi-phone-in-talk </v-icon>
              </v-btn>
            </template>
            <span>Test call in progress</span>
          </v-tooltip>
        </div>
        <div v-else-if="dialIsShowPhoneOnNavbar">
          <v-btn
            fab
            small
            class="btn-phone m-r-1"
            color="transparent"
            @click="toggleDialPanel"
          >
            <v-icon color="white"> fa-phone </v-icon>
          </v-btn>
        </div>
      </div>
      <v-tooltip v-else left>
        <template v-slot:activator="{ on }">
          <v-btn
            v-on="on"
            fab
            small
            style="cursor: default;"
            :class="`btn-phone ${btnIsCalling ? 'm-r-10' : 'm-r-1'}`"
            :color="btnIsCalling ? 'success' : 'transparent'"
            :ripple="!btnCallDisabled"
          >
            <v-icon v-if="btnIsCalling" size="20" color="white">
              mdi-phone-in-talk
            </v-icon>
            <v-icon v-else color="white"> fa-phone </v-icon>
          </v-btn>
        </template>
        <span>Test call in progress on other tab</span>
      </v-tooltip>
    </div>

    <div class="state-container">
      <state-dial v-if="dialIsOpenPanel && !btnIsCalling"></state-dial>
      <state-calling
        v-if="dialIsOpenPanel && btnIsCalling"
        :dialSession="dialSession"
        @hangup="hangup"
      ></state-calling>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import JsSIP from 'jssip'
import moment from 'moment'
import { mapGetters, mapActions } from 'vuex'
import { getCallId, setCallId, removeCallId } from '@/utils/call'
import apiCall from '@/apis/call'
import apiSetting from '@/apis/setting'
import apiChannel from '@/apis/channel'
import apiConversation from '@/apis/conversation'
import StateCalling from '../call/state_calling.vue'
import StateDial from '../call/state_dial.vue'

export default {
  name: 'PhoneButton',
  components: {
    StateCalling,
    StateDial
  },
  data() {
    return {
      dialUa: Object,
      dialSession: Object,
      search: {
        query: {},
        filter: {
          status: 'on call',
          channel: '',
          qc: {}
        },
        from: '',
        to: '',
        sortBy: ['created_at'],
        sortDesc: [true],
        page: 1,
        limit: 10
      },
      dateFormat: 'YYYY-MM-DD HH:mm',
      btnCallDisabled: false,
      btnIsCalling: false,
      is_fetch_calling: true,
      is_calling: null,
      reload: '',
      hangupStatus: 'ended by system',
      intervalCall: 3000,
      callingExpiredTime: 30 // 30 min.
    }
  },
  created() {
    this.initial()

    if (this.dialIsCalling) {
      this.btnCallDisabled = true
      this.clearDialIsOpenPanel()
    } else {
      this.btnCallDisabled = false
    }

    window.addEventListener('beforeunload', this.beforeWindowUnload)
    window.addEventListener('unload', this.onWindowUnload)
  },
  beforeDestroy() {
    window.removeEventListener('beforeunload', this.beforeWindowUnload)
  },
  async destroyed() {
    this.onWindowUnload()
    window.removeEventListener('unload', this.onWindowUnload)
  },
  mounted() {
    this.setDialTimeRunning(true)
    this.setDialTimeStarted(setInterval(this.clockRunning, 10))
  },
  computed: {
    ...mapGetters('auth', ['user']),
    ...mapGetters('call', [
      'dialIsShowPhoneOnNavbar',
      'dialPhoneNumber',
      'dialChannelName',
      'dialIsOpenPanel',
      'dialIsCalling',
      'dialIsAllow',
      'dialVolume',
      'dialTo',

      'dialTime',
      'dialTimeBegan',
      'dialTimeStarted',
      'dialTimeStopped',
      'dialTimeStoppedDuration',
      'dialTimeRunning',
      'dialTimerBegan'
    ])
  },
  watch: {
    dialIsCalling: {
      immediate: true,
      handler(val) {
        this.btnIsCalling = val
        if (val) {
          if (this.is_calling !== null) this.call()
        } else {
          this.btnCallDisabled = false
        }
      }
    },
    is_calling: {
      immediate: true,
      async handler(val) {
        if (val === true) {
          this.btnIsCalling = true
          this.is_fetch_calling = true
          if (_.isEmpty(this.dialSession)) this.btnCallDisabled = true
          await this.startCheckCalling()
        } else if (val === false) {
          this.btnIsCalling = false
          this.btnCallDisabled = false
          this.is_fetch_calling = false
          this.clearCalling()
        }
      }
    }
  },
  methods: {
    ...mapActions('call', [
      'setDialIsShowPhoneOnNavbar',
      'toggleDialPanel',
      'setDialSession',
      'setDialBotSessionId',
      'setDialIsCalling',
      'setDialIsAllow',
      'clearDialTo',
      'clearDialDtmf',
      'clearDialPhoneNumber',
      'clearDialChannelName',
      'clearDialBotSessionId',
      'clearDialIsShowNumPads',
      'clearDialIsOpenPanel',
      'clearDialIsCalling',
      'clearDialIsOnHold',
      'clearDialIsOnMute',

      'setDialTime',
      'setDialTimeBegan',
      'setDialTimeStarted',
      'setDialTimeStopped',
      'setDialTimeStoppedDuration',
      'setDialTimeRunning',
      'setDialTimerBegan'
    ]),
    async initial() {
      await this.startCheckCalling()
      this.initialDate()
      this.checkBrowserTab()
      this.initialPhoneClearState()
      this.checkAvaiableCall()
      if (this.dialIsAllow) this.initialWebRTC()
    },
    initialPhoneClearState() {
      const totalTab = localStorage.getItem('tabsOpen')
      if (this.dialIsCalling && parseInt(totalTab) == 1)
        this.clearDialIsCalling()
      // this.setDialIsShowPhoneOnNavbar(false)
      // this.setDialIsShowPhoneOnNavbar(true)
    },
    initialDate() {
      this.search.from = moment()
        .startOf('day')
        .format(this.dateFormat)
      this.search.to = moment()
        .startOf('day')
        .add(1, 'days')
        .format(this.dateFormat)
    },
    checkBrowserTab() {
      const tabsOpen = localStorage.getItem('tabsOpen')
      if (tabsOpen == null) localStorage.setItem('tabsOpen', 1)
      else localStorage.setItem('tabsOpen', parseInt(tabsOpen) + parseInt(1))

      window.onunload = e => {
        const newTabCount = localStorage.getItem('tabsOpen')
        if (newTabCount !== null)
          localStorage.setItem('tabsOpen', newTabCount - 1)
      }
    },
    checkAvaiableCall() {
      const have = this.user.role.pages.includes('Flows - Test call')
      this.setDialIsAllow(have)
    },
    async startCheckCalling() {
      await this.getCalling()
      if (this.is_calling) await this.setIntervalCall()
      else {
        this.clearCalling()
      }
    },
    clearCalling() {
      this.is_calling = false
      this.clearDialIsCalling()
      this.clearDialIsOpenPanel()
      this.clearDialBotSessionId()
      removeCallId()
      this.stopTimer()
      this.resetTimer()
    },
    async setIntervalCall() {
      this.reload = setInterval(this.checkInterval, this.intervalCall)
    },
    async checkInterval() {
      await this.getCalling()
      if (!this.is_calling) {
        clearInterval(this.reload)
        this.clearDialIsCalling()
      }
    },
    async initialWebRTC() {
      const settings = await apiSetting.getSetting()
      const isEnableWebRtc = _.find(settings.data, { key: 'webrtc_enable' })
        .value

      if (typeof isEnableWebRtc !== 'undefined' && isEnableWebRtc == 'true') {
        const webRtcUrl = _.find(settings.data, { key: 'webrtc_url' }).value
        const webRtcUser = _.find(settings.data, { key: 'webrtc_user' }).value
        const webRtcPassword = _.find(settings.data, { key: 'webrtc_password' })
          .value

        const socket = new JsSIP.WebSocketInterface(
          `wss://${webRtcUrl}:8089/ws`
        )
        const configuration = {
          sockets: [socket],
          uri: `sip:${webRtcUser}@${webRtcUrl}`,
          contact_uri: `sip:${webRtcUser}@${webRtcUrl}`,
          authorization_user: webRtcUser,
          password: webRtcPassword,
          display_name: 'TVO Chatbotix',
          session_timers: false,
          register_expires: 30
        }

        const newUa = new JsSIP.UA(configuration)
        this.dialUa = newUa
        const ua = this.dialUa
        ua.on('registered', data => {})
        this.registerWebRTC()
      }
    },
    registerWebRTC() {
      const ua = this.dialUa
      ua.registrator().setExtraHeaders(['X-Foo: bar'])
      ua.on('newRTCSession', data => {
        const sessionData = data.session
        this.dialSession = sessionData
        const session = this.dialSession
        session.on('connecting', data => {})
      })
      ua.on('sipEvent', data => {})
      ua.on('hold', data => {})
      ua.start()
    },
    async call() {
      const ua = this.dialUa
      let session = this.dialSession

      const eventHandlers = {
        progress: e => {
          // console.log('call is in progress')
        },
        failed: async e => {
          // console.log('call failed with cause: ' + e.cause)
          await this.stateFailed()
        },
        ended: async e => {
          // console.log('call ended', e)
          await this.stateHangUp()
        },
        confirmed: e => {
          // console.log('call confirmed')
          this.stateCalling()
        },
        peerconnection: e => {
          e.peerconnection.onaddstream = event => {
            // console.log('on add stream from remote - ', event)
          }
        }
      }

      const options = {
        eventHandlers: eventHandlers,
        mediaConstraints: { audio: true, video: false }
      }

      const phoneNumber = await this.getPhoneNumber(this.dialPhoneNumber)
      session = ua.call(`sip:${phoneNumber}`, options)
      await this.insertLogCallStart()
      this.is_calling = true

      if (session) {
        session.connection.addEventListener('addstream', e => {
          const audio = document.createElement('audio')
          audio.setAttribute('id', 'audio-volume')
          audio.srcObject = e.stream
          audio.volume = this.dialVolume
          document.body.appendChild(audio)
          audio.play()
        })
      }
    },
    async getPhoneNumber(number) {
      let phoneNumber = number
      const phoneNumberPattern = /^(08[0-9]{8}|09[0-9]{8}|06[0-9]{8}|0[0-9]{8}|[0-9]{6})*$/

      if (phoneNumberPattern.test(phoneNumber)) {
        phoneNumber = await this.telephonySetting(number)
      }

      return phoneNumber
    },
    async telephonySetting(number) {
      let phoneNumber = number

      const settings = await apiSetting.getSetting()

      const isAddZero = _.find(settings.data, {
        key: 'is_add_zero_phone_number'
      }).value
      if (typeof isAddZero !== 'undefined' && isAddZero == 'true') {
        if (phoneNumber[0] !== '0') {
          phoneNumber = `0${phoneNumber}`
        }
      }

      const isRemoveZero = _.find(settings.data, {
        key: 'is_remove_zero_phone_number'
      }).value
      if (typeof isRemoveZero !== 'undefined' && isRemoveZero == 'true') {
        if (phoneNumber[0] === '0') {
          phoneNumber = phoneNumber.slice(1)
        }
      }

      const isPrefix = _.find(settings.data, { key: 'is_prefix_phone_number' })
        .value
      if (typeof isPrefix !== 'undefined' && isPrefix == 'true') {
        const prefix = _.find(settings.data, { key: 'prefix_phone_number' })
          .value
        phoneNumber = `${prefix}${phoneNumber}`
      }

      const isSuffix = _.find(settings.data, { key: 'is_suffix_phone_number' })
        .value
      if (typeof isSuffix !== 'undefined' && isSuffix == 'true') {
        const suffix = _.find(settings.data, { key: 'suffix_phone_number' })
          .value
        phoneNumber = `${phoneNumber}${suffix}`
      }

      return phoneNumber
    },
    checkCallingExpired(dateTimeStart) {
      let isExpired = false
      const current = moment()
      const expired = moment(dateTimeStart).add(this.callingExpiredTime, 'm')
      if (current > expired) isExpired = true
      return isExpired
    },
    async getCalling() {
      if (this.is_fetch_calling) {
        const result = await apiCall.getLatestCallByUserId({
          userId: this.user._id
        })
        if (result.code === 0) {
          const { call_id, is_calling, created_at } = result.data
          this.is_calling = is_calling
          if (this.is_calling) {
            if (!this.checkCallingExpired(created_at)) {
              const session_no = result.data.session_no
              await this.updateLogCallStatusBySessionNo(session_no)
            } else {
              await apiCall.updateCallStatus(call_id, {
                isCalling: false,
                status: 'ended by system'
              })
            }
          }
        } else {
          this.is_calling = false
        }
      }
    },
    async insertLogCallStart() {
      try {
        const flowName = this.dialPhoneNumber === this.dialTo ? '' : this.dialTo
        const data = {
          phoneNumber: this.dialPhoneNumber,
          flowName,
          channelName: this.dialChannelName,
          userId: this.user._id
        }
        const call = await apiCall.callStart(data)
        setCallId(call.data.call_id)
      } catch (err) {}
    },
    async insertLogCallEnd(status) {
      try {
        const callId = getCallId()
        const data = { callId, status }
        await apiCall.callEnd(data)
      } catch (err) {}
    },
    async updateLogCallSessionNo(sessionNo) {
      try {
        const callId = getCallId()
        const data = { sessionNo }
        await apiCall.updateSessionNo(callId, data)
      } catch (err) {}
    },
    async updateLogCallStatusBySessionNo(sessionNo) {
      try {
        const data = { sessionNo }
        await apiCall.updateStatusBySessionNo(data)
      } catch (err) {}
    },
    async deleteChannel() {
      try {
        const channels = await apiChannel.getChannel()
        const channelId = _.find(channels.data, {
          channelName: this.dialChannelName
        })._id
        if (channelId) await apiChannel.deleteChannel(channelId)
      } catch (err) {}
    },
    async getConversation() {
      try {
        this.search.filter.channel = this.dialPhoneNumber
        const callers = await apiConversation.getCaller(this.search)
        if (callers.data && callers.data.docs.length > 0) {
          const botSessionId = callers.data.docs[0].bot_session_id
          if (botSessionId) {
            this.setDialBotSessionId(botSessionId)
            this.updateLogCallSessionNo(botSessionId)
          }
        }
      } catch (err) {}
    },
    stateCalling() {
      this.hangupStatus = 'ended by system'
      this.setDialIsCalling(true)
      this.deleteChannel()
      this.resetTimer()
      this.startTimer()
      setTimeout(() => this.getConversation(), 300)
    },
    async stateFailed() {
      await this.insertLogCallEnd('error')
      this.clearDialIsCalling()
      this.stopTimer()
      this.resetTimer()
      this.clearDialChannelName()
      this.clearDialPhoneNumber()
      this.clearDialDtmf()
      this.clearDialTo()
      this.clearDialIsOnHold()
      this.clearDialIsOnMute()
      this.clearDialIsShowNumPads()
      this.clearDialIsOpenPanel()
      this.deleteChannel()
    },
    async stateHangUp() {
      this.is_calling = false
      await this.insertLogCallEnd(this.hangupStatus)
      this.clearDialIsOpenPanel()
      this.clearDialIsCalling()
      this.stopTimer()
      this.resetTimer()
      this.clearDialChannelName()
      this.clearDialPhoneNumber()
      this.clearDialIsOnMute()
      this.clearDialDtmf()
      this.clearDialTo()
      this.clearDialIsOnHold()
      this.clearDialBotSessionId()
      this.clearDialIsShowNumPads()
      document.getElementById('audio-volume').remove()
    },
    startTimer() {
      if (this.dialTimerBegan === null) {
        this.resetTimer()
        this.setDialTimerBegan(new Date())
      }
      if (this.dialTimeStopped !== null) {
        this.setDialTimeStoppedDuration(
          this.dialTimeStoppedDuration + new Date() - this.dialTimeStopped
        )
      }
      this.setDialTimeStarted(setInterval(this.clockRunning, 10))
      this.setDialTimeRunning(true)
    },
    stopTimer() {
      this.setDialTimeRunning(false)
      this.setDialTimeStopped(new Date())
      clearInterval(this.dialTimeStarted)
    },
    resetTimer() {
      this.setDialTimeRunning(false)
      clearInterval(this.dialTimeStarted)
      this.setDialTimeStoppedDuration(0)
      this.setDialTimerBegan(null)
      this.setDialTimeStopped(null)
      this.setDialTime('00:00')
    },
    clockRunning() {
      if (this.dialTimerBegan != null) {
        let currentTime = new Date(),
          timeElapsed = new Date(
            currentTime - this.dialTimerBegan - this.dialTimeStoppedDuration
          ),
          hour = timeElapsed.getUTCHours(),
          min = timeElapsed.getUTCMinutes(),
          sec = timeElapsed.getUTCSeconds()

        if (hour > 0) {
          this.setDialTime(
            this.zeroPrefix(hour, 2) +
              ':' +
              this.zeroPrefix(min, 2) +
              ':' +
              this.zeroPrefix(sec, 2)
          )
        } else {
          this.setDialTime(
            this.zeroPrefix(min, 2) + ':' + this.zeroPrefix(sec, 2)
          )
        }
      }
    },
    zeroPrefix(num, digit) {
      let zero = ''
      for (let i = 0; i < digit; i++) zero += '0'
      return (zero + num).slice(-digit)
    },
    hangup() {
      this.hangupStatus = 'ended by user'
      this.is_calling = false
      const session = this.dialSession
      if (session) session.terminate()
    },
    beforeWindowUnload(e) {
      if (this.dialIsCalling) {
        e.preventDefault()
        e.returnValue = ''
      }
    },
    async onWindowUnload(e) {
      this.hangup()
      await this.stateHangUp()
    }
  }
}
</script>

<style lang="scss" scoped>
.state-container {
  position: absolute;
  display: block;
  right: 2px;
  top: 50px;
}
.btn-phone {
  box-shadow: none;
  border-radius: 50%;
}
</style>
